import { useMemo } from 'react';
import { theme } from '@xbto/design-system';
import { convertHexToRGBA } from '../../../../utils';
export const useChartColors = (selectedSeries) => {
    const assetAmountColor = theme.color.border.info;
    const assetAmountColorMuted = convertHexToRGBA(assetAmountColor, 30);
    const usdValueColor = theme.color.border.warning;
    const usdValueColorMuted = convertHexToRGBA(usdValueColor, 30);
    return useMemo(() => {
        return {
            assetAmount: selectedSeries === 'asset-amount'
                ? assetAmountColor
                : assetAmountColorMuted,
            usdValue: selectedSeries === 'usd-value' ? usdValueColor : usdValueColorMuted,
        };
    }, [selectedSeries]);
};
